import { Form, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import IllustrationImage from "../../components/shared/illustration-image/illustration-image.component";
import FormFooterButtons from "../form-footer-buttons/form-footer-buttons.component";
import SectionTitle from "../../components/section-title/section-title.component";
import { useLazyQuery } from "@apollo/client";
import {
  CATEGORY_SEARCH,
  FETCH_SUBCATEGORIES_BY_CATEGORY,
} from "../../services/graphql/product";
import Multiselect from "multiselect-react-dropdown";
import { primaryOrange } from "../../constants/color";

const ServiceGeneralInfoForm = ({
  handleNextClick,
  setGeneralInfo,
  formValue,
}) => {
  const [validated, setValidated] = useState(false);

  const currentDate = new Date();
  const formatedDate = format(currentDate, "yyyy-MM-dd");

  const [name, setName] = useState("");
  const [serviceStartDate, setServiceStartDate] = useState("");
  const [serviceEndDate, setServiceEndDate] = useState("");
  const [serviceDescription, setServiceDescription] = useState("");

  const [selectedCategory, setSelectedCategory] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [subcategoriesList, setSubcategoriesList] = useState([]);
  const [selectedSubcategories, setSelectedSubcategories] = useState([]);
  const [isSubcategories, setIsSubcategories] = useState(false);
  const [errorFields, setErrorFields] = useState({
    selectedCategory: "", // for validation message
  });

  useEffect(() => {
    if (formValue.name && formValue.name !== "") {
      setName(formValue.name);
      setServiceStartDate(formValue.serviceStartDate);
      setServiceEndDate(formValue.serviceEndDate);
      setServiceDescription(formValue.serviceDescription);
      setSelectedCategory(formValue.selectedCategory);
      setSelectedSubcategories(formValue.selectedSubcategories);
      if (
        formValue.selectedSubcategories &&
        formValue.selectedSubcategories.length > 0
      ) {
        fetchSubCategoriesByCategoryId({
          variables: {
            categoryId: formValue.selectedCategory[0]._id,
          },
        });
        setIsSubcategories(true);
      }
    }

    getCategory();
  }, []);

  const getCategory = async () => {
    await categorySearch({
      variables: {
        query: "",
      },
    });
  };

  const handleOnChange = async (selectedList, type) => {
    if (type === "category") {
      setErrorFields((prev) => ({ ...prev, selectedCategory: "" })); // clear error
      const selectedItem = selectedList[0];
      const selectedItemList = [
        { _id: selectedItem._id, name: selectedItem.name },
      ];
      setSelectedCategory(selectedItemList);

      if (selectedItem.subCategories && selectedItem.subCategories.length > 0) {
        await fetchSubCategoriesByCategoryId({
          variables: {
            categoryId: selectedItem._id,
          },
        });
        setIsSubcategories(true);
      } else {
        setSubcategoriesList([]);
        setSelectedSubcategories([]);
        setIsSubcategories(false);
      }
    } else {
      const updatedCategory = [
        {
          _id: selectedCategory[0]?._id,
          name: selectedCategory[0]?.name,
          subCategories: selectedList,
        },
      ];
      setSelectedCategory(updatedCategory);
      setSelectedSubcategories(selectedList);
    }
  };

  const handleOnRemove = (selectedList, type) => {
    if (type === "category") {
      if (selectedList.length === 0) {
        setSelectedCategory([]);
        setIsSubcategories(false);
        setSelectedSubcategories([]);
        setErrorFields((prev) => ({
          ...prev,
          selectedCategory: "Please select a category.",
        }));
      } else {
        setSelectedCategory(selectedList);
        setIsSubcategories(true);
      }
    } else {
      setSelectedSubcategories(selectedList);
    }
  };

  const [fetchSubCategoriesByCategoryId] = useLazyQuery(
    FETCH_SUBCATEGORIES_BY_CATEGORY,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
      onCompleted: (data) => {
        if (data && data.fetchSubCategoriesByCategoryId) {
          let listOfSubCategory = data.fetchSubCategoriesByCategoryId;
          setSubcategoriesList(listOfSubCategory);
        } else {
        }
      },
    }
  );

  const [categorySearch, { loading: loadingCategoryList }] = useLazyQuery(
    CATEGORY_SEARCH,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
      onCompleted: (data) => {
        if (data && data.categorySearch) {
          let listOfCategory = data.categorySearch;
          setCategoriesList(listOfCategory);
        } else {
        }
      },
    }
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    let formValid = true;
    const newErrors = { selectedCategory: "" };

    // Validate category (must have one selected)
    if (selectedCategory.length === 0) {
      newErrors.selectedCategory = "Please select a category.";
      formValid = false;
    }

    setErrorFields(newErrors);
    setValidated(true);

    if (formValid) {
      setGeneralInfo(
        name,
        serviceStartDate,
        serviceEndDate,
        selectedCategory,
        selectedSubcategories,
        serviceDescription
      );
      handleNextClick();
    }
  };

  return (
    <div>
      <div style={{ marginTop: "5%", marginBottom: "3%" }}>
        <SectionTitle
          title={"General Information"}
          subtitle={"Fill all fields below"}
        />
      </div>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md="6" lg="6" style={{ marginLeft: "3%" }}>
            <Col md="12" lg="12">
              <Form.Group
                controlId="validationCustom01"
                style={{ color: "#A6A6A6" }}
              >
                <Form.Label>Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Name"
                  value={name}
                  onChange={(value) => {
                    if (value.target.value.trim().length !== 0) {
                      setName(value.target.value);
                    } else {
                      setName("");
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid name.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <div style={{ display: "flex", marginTop: "20px" }}>
              <Col md="6" style={{ color: "#A6A6A6", paddingRight: "10px" }}>
                <Form.Group controlId="validationCustom01">
                  <Form.Label>Start service date {formatedDate}</Form.Label>
                  <Form.Control
                    required
                    type="date"
                    min={formatedDate}
                    pattern="yyy/mm/dd"
                    placeholder="yyyy/mm/dd"
                    value={serviceStartDate}
                    onChange={(value) => {
                      setServiceStartDate(value.target.value);
                    }}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid start service date.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md="6" style={{ color: "#A6A6A6" }}>
                <Form.Group controlId="validationCustom01">
                  <Form.Label>End service date</Form.Label>
                  <Form.Control
                    required
                    type="date"
                    min={serviceStartDate}
                    pattern="yyy/mm/dd"
                    placeholder="yyyy/mm/dd"
                    value={serviceEndDate}
                    onChange={(value) => {
                      setServiceEndDate(value.target.value);
                    }}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid end service date.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </div>
            <div style={{ marginTop: "3%", display: "flex" }}>
              <Col
                xl="6"
                md="6"
                lg="6"
                style={{ color: "#A6A6A6", paddingRight: "10px" }}
              >
                <Form.Group
                  controlId="validationCustom02"
                  style={{ color: "#A6A6A6" }}
                >
                  <Form.Label>Category</Form.Label>
                  <Multiselect
                    options={categoriesList} // Options to display in the dropdown
                    // selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                    onSelect={(selectedList, selectedItem) => {
                      handleOnChange(selectedList, "category");
                    }} // Function will trigger on select event
                    onRemove={(selectedList) => {
                      handleOnRemove(selectedList, "category");
                    }} // Function will trigger on remove event
                    displayValue="name" // Property name to display in the dropdown options
                    showCheckbox
                    selectionLimit={1}
                    selectedValues={selectedCategory}
                    closeOnSelect={true}
                    style={{
                      chips: {
                        background: primaryOrange,
                      },
                    }}
                    isInvalid={!!errorFields.selectedCategory}
                  />
                  {errorFields.selectedCategory && (
                    <label style={{ fontSize: "0.875rem", color: "#dc3545" }}>
                      {errorFields.selectedCategory}
                    </label>
                  )}
                  <Form.Control.Feedback type="invalid">
                    Please select a sub-category.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col
                xl="6"
                md="6"
                lg="6"
                style={{ color: "#A6A6A6", paddingLeft: "10px" }}
              >
                <Form.Group
                  controlId="validationCustom02"
                  style={{ color: "#A6A6A6" }}
                >
                  <Form.Label>Sub-category</Form.Label>
                  <Multiselect
                    options={subcategoriesList} // Options to display in the dropdown
                    // selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                    onSelect={(selectedList) => {
                      handleOnChange(selectedList, "subCategory");
                    }} // Function will trigger on select event
                    onRemove={(selectedList) => {
                      handleOnRemove(selectedList, "subCategory");
                    }} // Function will trigger on remove event
                    displayValue="name" // Property name to display in the dropdown options
                    showCheckbox
                    selectionLimit={3}
                    selectedValues={selectedSubcategories}
                    style={{
                      chips: {
                        background: primaryOrange,
                      },
                    }}
                    disable={!isSubcategories}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please select a sub-category.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </div>
            <Col md="12" style={{ color: "#A6A6A6", marginTop: "20px" }}>
              <Form.Group controlId="validationCustom01">
                <Form.Label>Service description</Form.Label>
                <Form.Control
                  required
                  as="textarea"
                  rows={7}
                  maxLength={1000}
                  placeholder="Service description"
                  value={serviceDescription}
                  onChange={(value) => {
                    if (value.target.value.trim().length !== 0) {
                      setServiceDescription(value.target.value);
                    } else {
                      setServiceDescription("");
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid service description.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <FormFooterButtons nextButtonText={"Continue"} />
          </Col>
          <Col
            md="5"
            lg="5"
            style={{
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <IllustrationImage />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ServiceGeneralInfoForm;
